import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import ProgressOverview from '#components/o/MeineAusbildung/ProgressOverview'
import NumberRow from '#components/m/MeineAusbildung/NumberRow'

function WissensportalDashboard(props) {
  const {wissensportalCompletion} = props
  // eslint-disable-next-line max-len

  const showEmptyTile =
    isUndefined(wissensportalCompletion.notStartedPercentage) ||
    isUndefined(wissensportalCompletion.inProgressPercentage) ||
    isUndefined(wissensportalCompletion.finishedPercentage)

  if (showEmptyTile) {
    return <EmptyTile />
  }

  return (
    <ProgressOverview titleKey="menu_item_wissensportal" percentage={wissensportalCompletion.finishedPercentage}>
      <div data-testid="wissensportaldashboard" className="wissensportaldashboard">
        <NumberRow numbers={sortNumbers(wissensportalCompletion)} />
      </div>
    </ProgressOverview>
  )
}

function EmptyTile() {
  return (
    <ProgressOverview titleKey="menu_item_wissensportal" showProgressbar={false}>
      <div data-testid="wissensportaldashboard" className="wissensportaldashboard">
        <span>{i18n.t('loading_dashboard_data_failed')}</span>
      </div>
    </ProgressOverview>
  )
}

function isUndefined(number) {
  return typeof number === 'undefined'
}

function sortNumbers(numbers) {
  const sortedNumbers = [
    {
      color: 'green',
      value: numbers.finishedPercentage,
      symbol: '%',
      label: 'wissensportal_status_FINISHED',
    },
    {
      color: 'blue',
      value: numbers.inProgressPercentage,
      symbol: '%',
      label: 'wissensportal_status_IN_PROGRESS',
    },
    {
      color: 'grey',
      value: numbers.notStartedPercentage,
      symbol: '%',
      label: 'wissensportal_status_NOT_STARTED',
    },
  ]
  return sortedNumbers
}

WissensportalDashboard.propTypes = {
  wissensportalCompletion: PropTypes.shape({
    finishedPercentage: PropTypes.number,
    inProgressPercentage: PropTypes.number,
    notStartedPercentage: PropTypes.number,
  }),
}
export default WissensportalDashboard
